import type React from 'react';
import { useIntl } from 'react-intl';

import * as S from './directory-list.styled';

export const ALPHABETH = 'abcdefghijklmnopqrstuvwxyz#äöü';

type Props = {
  route: string;
  letter?: string;
};

export const DirectoryList: React.FC<Props> = ({ route, letter }) => {
  const letters = ALPHABETH.split('');
  const { formatMessage } = useIntl();

  return (
    <nav>
      <S.List>
        {letters.map((character) => {
          const link = `${route}/${character === '#' ? 'weitere' : character}`;
          const letterReplacement =
            character === '#'
              ? formatMessage({
                  id: 'CRATE_MASTER_DIRECTORY_SPECIAL_CHARACTERS',
                })
              : character.toUpperCase();

          return (
            <S.ListItem key={character}>
              <S.TextButton
                to={
                  letter === character ||
                  (letter === 'weitere' && character === '#')
                    ? undefined
                    : link
                }
                $active={
                  letter?.toLocaleLowerCase() ===
                    character?.toLocaleLowerCase() ||
                  (letter === 'weitere' && character === '#')
                }
                aria-label={formatMessage(
                  {
                    id:
                      character === '#'
                        ? 'CRATE_MASTER_DIRECTORY_HEADLINE_OTHERS'
                        : 'CRATE_MASTER_DIRECTORY_HEADLINE',
                  },
                  {
                    letter: letterReplacement,
                  }
                )}
              >
                {character}
              </S.TextButton>
            </S.ListItem>
          );
        })}
      </S.List>
    </nav>
  );
};
